import { render } from "./EventDetailsSave.vue?vue&type=template&id=5b752ae8"
import script from "./EventDetailsSave.vue?vue&type=script&lang=js"
export * from "./EventDetailsSave.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__